document.addEventListener('DOMContentLoaded', () => {
	document.querySelectorAll('img.base').forEach(img => {
		img.setAttribute('draggable', 'false');
	});
	class NylonSlider extends HTMLElement {
		constructor() {
			super();

			this.slider = this.querySelector('#line-scroll');
			this.filtered = this.querySelector('#filtered');
			this.container = this.querySelector("#content");

			this.dragging = false;

			// Initial setup to avoid flicker
			if (this.slider && this.filtered && this.container) {
				const rect = this.container.getBoundingClientRect();
				const x = rect.width / 2; // starting position centered
				const percent = (x / rect.width) * 100;

				this.slider.style.left = `${percent}%`;
				this.filtered.style.clipPath = `inset(0 0 0 ${x}px)`;
			}

			this._bindEvents();
			this._forceReflowOnOrientation();

			// Add 'ready' class to show the element after initialization
			this.classList.add('ready');
		}

		_bindEvents() {
			if (!this.slider || !this.filtered || !this.container) {
				console.warn('Nylon components not defined');
				return;
			}

			// Mouse
			this.slider.addEventListener('mousedown', this._startDrag.bind(this));
			window.addEventListener('mouseup', this._endDrag.bind(this));
			window.addEventListener('mousemove', this._onDrag.bind(this));

			// Touch
			this.slider.addEventListener('touchstart', this._startDrag.bind(this), { passive: false });
			window.addEventListener('touchend', this._endDrag.bind(this));
			window.addEventListener('touchmove', this._onDrag.bind(this), { passive: false });
		}

		_startDrag(e) {
			this.dragging = true;
		}

		_endDrag(e) {
			this.dragging = false;
		}

		_onDrag(e) {
			if (!this.dragging) return;

			const rect = this.container.getBoundingClientRect();
			const clientX = e.touches?.[0]?.clientX ?? e.clientX;

			if (typeof clientX !== 'number') return;

			let x = clientX - rect.left;

			const padding = rect.width * 0.01;
			x = Math.max(padding, Math.min(x, rect.width - padding));

			const percent = (x / rect.width) * 100;
			this.slider.style.left = `${percent}%`;
			this.filtered.style.clipPath = `inset(0 0 0 ${x}px)`;

			if (e.cancelable) e.preventDefault();
		}

		_forceReflowOnOrientation() {
			window.addEventListener('orientationchange', () => {
				setTimeout(() => {
					const event = new Event('resize');
					window.dispatchEvent(event);
				}, 500);
			});
		}
	}

	customElements.define('nylon-slider', NylonSlider);
});
